<template>
  <div id="evn-wrapper-v2" class="evn-wrapper-v2">
    <div class="content-wrapper">
      <h1 class="sr-only">Verbindungsnachweise – Konto & Service</h1>
      <h2 class="text-3xl text-align-left full-width">Verbindungsnachweise</h2>
      <change-evn></change-evn>

      <evn-bills-overview :extraData="extraData"></evn-bills-overview>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ChangeEvn from '../ChangeEvn.vue'
import EvnBillsOverview from '../EvnBillsOverview.vue'
import extraData from '../../../../../mixins/extraData'

export default {
  name: 'EvnWrapperV2',
  components: { EvnBillsOverview, ChangeEvn },

  data () {
    return {
      loading: false,
      splittedItemisedBills: {
        all: [],
        national: [],
        sms: [],
        mms: [],
        ausland: [],
        roaming: [],
        topupAndVoucher: [],
        lastMonth: [],
        currentMonth: [],
        other: []
      }
    }
  },
  mixins: [
    extraData()
  ],
  methods: {
    save: async function () {
      this.loading = true
      await this.saveEvnSettings({ selectedEvn: this.currentEvnConfiguration.evn })
      this.loading = false
    }
  },
  computed: {
    ...mapGetters([
      'accessToken'
    ])
  }
}

</script>
